export const ID_PREFIX = {
  FOLDER_STRUCTURE_REVISION: "txo_folderstructurerevision_",
  TAG: "txo_tag_",
  TAG_KIND: "txo_tagkind_",
  TAXONOMY: "txo_taxonomy_",
} as const;
